import { createSelector } from 'reselect'
import get from 'lodash.get'
export const getIntent = state => state.maya.intent
export const getMessages = state => state.maya.messages
export const getIsMayaResponding = state => state.maya.isMayaResponding
export const getSearchResults = state => state.maya.searchResults

const getLastAssistantMessage = messages => {
  if (!Array.isArray(messages)) return null

  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === 'assistant') {
      return messages[i]
    }
  }

  return null // Return null if no assistant message is found
}

const sortGridItems = (items, assistantMessage) => {
  // Sort the items in the grid based on the lastAssistantMessage content
  const sortedItems = [...items].sort((a, b) => {
    let content = assistantMessage?.content || ''

    // Clean URLs in content by removing everything after #
    // Matches URLs starting with http://, https://, www. or just domain names
    content = content.replace(
      /(https?:\/\/|www\.)?[^\s#]+(#[^\s]+)?/g,
      url => url.split('#')[0]
    )

    // Remove everything after and including '#' from URLs
    const urlA = a.url.split('#')[0]
    const urlB = b.url.split('#')[0]

    const indexA = content.indexOf(urlA)
    const indexB = content.indexOf(urlB)

    // Items with URLs in content come first, in order of appearance
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB
    }
    // Items with URLs in content come before items not in content
    if (indexA !== -1) return -1
    if (indexB !== -1) return 1

    // Keep original order for items not in content
    return 0
  })

  return sortedItems
}

export const getGrids = createSelector(
  [getIntent, getMessages, getIsMayaResponding],
  (intent, messages, isMayaResponding) => {
    if (!intent || !intent.response || !intent?.type) return null

    let intentRes = get(intent, `response.${intent.type}`, null)

    if (!intentRes) return null

    let resultantGrids = {}

    const lastAssistantMessage = getLastAssistantMessage(messages)

    for (let grid of intentRes.grids) {
      if (!resultantGrids[grid.content_type] && grid?.items?.length) {
        // IF ASSISTANT RESPONSE MESSAGE FOUND
        // THEN SORT GRID ITEMS BASED ON APPEARANCE ORDER IN ASSISTANT TEXT
        // ALSO DO NOT SORT WHEN THE ASSISTANT RESPONSE IS GENERATING
        const sortedItems =
          lastAssistantMessage && !isMayaResponding
            ? sortGridItems(grid.items, lastAssistantMessage)
            : grid.items

        resultantGrids[grid.content_type] = {
          ...grid,
          items: sortedItems,
          id: Date.now(),
        }
      }
    }

    return resultantGrids
  }
)

export const getSearchGrids = createSelector(
  [getSearchResults],
  searchResults => {
    if (!searchResults || !searchResults?.grids?.length) return null

    let resultantGrids = {}

    for (let grid of searchResults.grids) {
      if (!resultantGrids[grid.content_type] && grid?.items?.length) {
        resultantGrids[grid.content_type] = grid
        resultantGrids[grid.content_type]['id'] = Date.now()
      }
    }

    return resultantGrids
  }
)

export const getSearchFilters = createSelector(
  [getSearchResults],
  searchResults => {
    if (!searchResults || !searchResults.filters) return null

    const resultantFilters = Object.values(searchResults.filters)
      .filter(({ value }) => Array.isArray(value) && value.length > 0) // Filter out empty or undefined arrays
      .map(({ title, value }) => ({
        title,
        value: value
          .map(item => item.charAt(0).toUpperCase() + item.slice(1)) // Capitalize first letter
          .join(', '), // Convert array to comma-separated string
      }))

    return resultantFilters
  }
)
